module.exports = __webpack_public_path__ + "static/media/structure3.b2c4f750.png";